import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';
import i18n from "../i18n/translate";

const NOTIFICATION_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
  WARNING: 'warning'
};

export default class InlineNotification extends Component {
  static propTypes = {
    children: PropTypes.any,
    closeAction: PropTypes.func,
    show: PropTypes.bool,
    type: PropTypes.string
  };

  static defaultProps = {
    type: NOTIFICATION_TYPES.SUCCESS,
    show: true
  };

  constructor(props) {
    super(props);
    this.state = {
      visible: this.props.show
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.show !== this.props.show) {
      this.setState({ visible: newProps.show });
    }
  }

  getIconType = () => {
    switch (this.props.type) {
    case NOTIFICATION_TYPES.ERROR:
      return 'minus-circle';
    case NOTIFICATION_TYPES.INFO:
      return 'info-outline';
    case NOTIFICATION_TYPES.WARNING:
      return 'alert-triangle';
    default:
      return 'check-circle';
    }
  };

  onClose = () => {
    this.setState({ visible: false });
  };

  render() {
    const close = this.props.closeAction || this.onClose;
    return this.state.visible ? (
      <div className={`inline-notification-banner ${this.props.type}`}>
        <div className="banner-icon">
          <Icon iconType={this.getIconType()}/>
        </div>
        <div className="banner-text">
          {this.props.children}
        </div>
        <button className="banner-close-button" aria-label={i18n.t('Dismiss Notification')} onClick={close}>
          <Icon iconType="close" additionalClasses="banner-close" />
        </button>
      </div>
    ) : null;
  }
}
